<template>
	<div>
		<v-dialog v-model="dialog_field" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">

        	<v-card>
        		<v-toolbar flat>
				    <v-toolbar-side-icon @click="$parent.fn_closeDialog"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <v-toolbar-title class="white--text">
				    	<span v-if="$parent.Form.dynamicFields.section">{{$parent.Form.dynamicFields.section.sectionName}}</span>
				    </v-toolbar-title>

				    <v-spacer></v-spacer>

				    <v-btn round-borders outline @click="fn_checkValidations">{{ $route.query.section_id && this.$route.query.section_id != 'einvoice_details' ? 'Save' : 'Done' }}</v-btn>
				</v-toolbar>

        	  	<v-card-text full-height nopadding grey-back>
        	  		<v-form data-vv-scope="fields" full-width data-no-translate>

        	  			<!-- <v-flex xs12 sm12 md12 form-item @click="fn_openAccountLedgers(null, null)">
							<v-text-field  
			               	readonly
			               	v-model="accountvalue" 
			               	label="account" 
			               	placeholder=" " 
			               	append-icon="arrow_drop_down"
			               	:onUpdate="fn_updateAccountLedger"
			               	ref="ref_dialogDynamicFields_ledger">
		               </v-text-field>
						</v-flex> -->

        	  			<v-layout row wrap padding-top-bottom-ten white-background>
        	  				<div full-width v-for="(item, index) in $parent.Form.dynamicFields.items" :key="index">
        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='text'">
        	  					  	<v-text-field  
        	  					  		:label="item.displayName" 
        	  					  		type="text" 
        	  					  		v-model="item.value" 
        	  					  		placeholder=" " 
        	  					  		v-validate="item.isRequired ? 'required|max:'+item.additionalData.maxLength : 'max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
										:hide-details="item.displayName == 'Distance (In KM)'"
					               		required>
					               	</v-text-field>

									<div right-align v-if="item.displayName == 'Distance (In KM)'"><v-btn color="primary" capitalize small class="mr-0 pr-0" flat @click="$root.fn_openExternalUrl('https://ewaybillgst.gov.in/Others/P2PDistance.aspx')">Calculate Distance</v-btn></div>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='pincode'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="number" 
        	  							v-model.number="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|max'+item.additionalData.maxLength : 'max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  								
        	  						</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='mobileNumber'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="tel" 
        	  							v-model.number="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|max:'+item.additionalData.maxLength : 'max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  								
        	  						</v-text-field>
        	  					</v-flex>

								<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='email'">
									<v-text-field  
										:label="item.displayName" 
										type="email" 
										v-model="item.value" 
										placeholder=" "
										v-validate="item.isRequired ? 'required|email|max:'+item.additionalData.maxLength : 'email|max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
									</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='dateTime'" @click="openDatePicker('dynamicFieldDate-fid-'+item.fieldId, item.value)">

        	  						<v-text-field  
        	  							readonly
        	  							append-icon="arrow_drop_down"
        	  							:label="item.displayName"
        	  							:value="fn_formatDate(item.value)"
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required' : ''" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  						</v-text-field>
        	  						<!-- v-model="item.value"  -->
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='longText'">
        	  						<v-textarea  rows="2" 
        	  							:label="item.displayName" 
        	  							v-model="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|max:'+item.additionalData.maxLength : 'max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  						</v-textarea>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='number'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="number" 
        	  							v-model.number="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|numeric|max:'+item.additionalData.maxLength : 'numeric|max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  						</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='decimal'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="number" 
        	  							v-model.number="item.value"
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|decimal:2|max:'+item.additionalData.maxLength : 'decimal:2|max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  								
        	  						</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='choice'">
        	  						<!-- <div slot="label">{{item.displayName}}</div> -->
									<!-- item.additionalData.choices -->
        	  						<v-select
							          :items="item.filteredChoices && item.filteredChoices.length ? item.filteredChoices : item.additionalData.choices"
							          :label="item.displayName"
									  clearable
									  placeholder=" "
							          v-model="item.value"
									  @change="fn_assignChoiceFields(item)"
							        ></v-select>

							        <span class="error--text font-small" v-show="errors.has('fields.'+item.displayName) && !item.value">
								    	{{ errors.first('fields.'+item.displayName) }}
								    </span>

        	  						<!-- <v-radio-group v-model="item.value" row v-validate="item.isRequired ? 'required' : ''" :data-vv-name="item.displayName">
								      <v-radio :label="choiceItem" :value="choiceItem" v-for="(choiceItem, cIndex) in item.additionalData.choices" :key="cIndex"></v-radio>
								    </v-radio-group>
								    
								    <span class="error--text font-small" v-show="errors.has('fields.'+item.displayName) && !item.value">
								    	{{ errors.first('fields.'+item.displayName) }}
								    </span> -->
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='yes/no'">
        	  						<v-checkbox 
        	  							:label="item.displayName" 
        	  							right-align-checkbox 
        	  							v-model="item.value" 
        	  							v-validate="item.isRequired ? 'required' : ''" 
        	  							:data-vv-name="item.displayName"
        	  							@change="fn_updateCheckBoxValue(item)">
        	  						</v-checkbox>

        	  						<span class="error--text font-small" v-show="errors.has('fields.'+item.displayName) && !item.value">
        	  							{{ errors.first('fields.'+item.displayName) }}
        	  						</span>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='code'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="text" 
        	  							v-model="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required' : ''" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  						</v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='linkedItem'" @click="fn_openListItems(item.listItemId, item.value, item.listId, item.listName, item.fieldId)">
        	  						<v-text-field  
						               	readonly
						               	v-model="item.value" 
						               	:label="item.displayName" 
						               	placeholder=" " 
						               	append-icon="arrow_drop_down"
						               	:onUpdate="fn_updateLinkedItem"
						               	:ref="fn_getRef('ref_dialogDynamicFields_linkedItem-fid-', item.fieldId)"
						               	v-validate="item.isRequired ? 'required' : ''" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
					               </v-text-field>
        	  					</v-flex>

        	  					<!-- <div v-if="item.fieldType.value=='linkedItem'">

        	  						<v-layout wrap white-background margin-top-ten>
									  	<v-flex xs12 sm12 md12 form-item>

							               <v-list-tile nopadding light-opacity-color font14
								            	ref="ref_dialogDynamicFields_linkedItem" 
								            	:onUpdate="fn_updateLinkedItem"
								            	 @click="fn_openListItems(item.listItemId, item.value, item.listId, item.listName, item.additionalData.listMultiple)">
								            	<v-list-tile-content>
								                	<v-list-tile-title>{{item.displayName}}</v-list-tile-title>
								              	</v-list-tile-content>
								              	<v-list-tile-action>
								                	<v-icon>keyboard_arrow_right</v-icon>
								              	</v-list-tile-action>
								            </v-list-tile>
							            </v-flex>
										<div padding-all-16 v-if="item.value && item.value.length">

											<v-chip close outline label v-for="(linkedItem, index) in item.value" :key="index" @input="item.value.splice(linkedItem, 1)">{{linkedItem}}</v-chip>
										</div>
									</v-layout>
        	  					</div> -->

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='accountItem'" @click="fn_openAccountLedgers(item.accountLedgerId, item.value, item.accountGroupId, item.accountGroupName, item.fieldId)">
        	  						<v-text-field  
						               	readonly
						               	v-model="item.value" 
						               	:label="item.displayName" 
						               	placeholder=" " 
						               	append-icon="arrow_drop_down"
						               	:onUpdate="fn_updateAccountLedger"
						               	:ref="fn_getRef('ref_dialogDynamicFields_accountLedger-fid-', item.fieldId)"
						               	v-validate="item.isRequired ? 'required' : ''" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
					               </v-text-field>
        	  					</v-flex>

        	  					<v-flex xs12 sm12 md12 form-item v-if="item.fieldType=='phoneNumber'">
        	  						<v-text-field  
        	  							:label="item.displayName" 
        	  							type="tel" 
        	  							v-model.number="item.value" 
        	  							placeholder=" "
        	  							v-validate="item.isRequired ? 'required|max:'+item.additionalData.maxLength : 'max:'+item.additionalData.maxLength" 
					               		:data-vv-name="item.displayName" 
					               		:error-messages="errors.collect('fields.'+item.displayName)"
					               		required>
        	  						</v-text-field>
        	  					</v-flex>
        	  				</div>
        	  			</v-layout>
						
        	  		</v-form>
        	  		
        	  	</v-card-text>
	        </v-card>	
      	</v-dialog>
	</div>
</template>	 	

<script>
const menuItem = require('../../config.js').configs.menuItem;
const accountGroupIds = require('../../config.js').configs.accountGroupIds;
const fieldIds = require('../../config.js').configs.fieldIds;

export default{
	props:['saveFields', 'openAccountLedgers', 'openListItems', 'openDatePicker', 'saveItemFields'],
	data(){	
		return{
			dialog_field: false,
			dynamicFieldDate:null,
			isDirectSave:false
		}
	},
	methods:{
		// isDirectSave is using to save invoice directly if eway bill details edited directly from display view for eway bill json
		openDialogWeb: function () {
			this.dialog_field = true;
			this.isDirectSave = false;
		},
		closeDialogWeb: function () {
			this.dialog_field = false;
			if(this.$route.query.section_id && this.$route.query.section_id != 'einvoice_details'){
				if(this.isDirectSave){
					// saving invoice directly
					this.$parent.fn_checkValidations();
				}
				else{
					setTimeout(() => {
						// going back directly if user goes back without saving
						this.$parent.fn_goBack();
					}, 300);
				}
			}
		},
		fn_getRef: function(ref, fieldId){
			return ref + fieldId;
		},
		fn_openAccountLedgers: function (id, name, accountGroupId, accountGroupName, fieldId) {
			if(fieldIds.transporterName.id == fieldId){
				this.$parent.Form.dynamicFields.accountGroupId = accountGroupIds.transporter.id;
				this.$parent.Form.dynamicFields.accountGroupName = accountGroupIds.transporter.name;	
			}
			else{
				this.$parent.Form.dynamicFields.accountGroupId = accountGroupId;
				this.$parent.Form.dynamicFields.accountGroupName = accountGroupName;	
			}

			this.$parent.Form.dynamicFields.ref = 'ref_dialogDynamicFields_accountLedger-fid-'+fieldId;
			
			let accountGroups = [];
			accountGroups.push(this.$parent.Form.dynamicFields.accountGroupId);
			this.openAccountLedgers('android', 'AccountLedgers', 'ref_dialogDynamicFields_accountLedger-fid-'+fieldId, id, name, accountGroups);

		},
		fn_openListItems: function (id, name, listId, listName, fieldId) {
			this.$parent.Form.dynamicFields.ref = 'ref_dialogDynamicFields_accountLedger-fid-'+fieldId;
			this.openListItems('android', 'ListItems', 'ref_dialogDynamicFields_linkedItem-fid-'+fieldId, id, name, listId, listName);
		},
		fn_updateAccountLedger: function (selectedValueId, selectedValueName, isRemoved, ref, accountGroupId) {
			// accountGroupId coming from new ledger making directly via dialog
			if(this.$parent.Form.dynamicFields.accountGroupId == accountGroupIds.transporter.id && (accountGroupId && accountGroupId != accountGroupIds.transporter.id)){
				this.showToast("Invalid Transporter");
				return;
			}

			let items = this.$parent.Form.dynamicFields.items;

			let fieldRef = ref ? ref : this.$parent.Form.dynamicFields.ref;

			let fieldId = fieldRef.substring(fieldRef.lastIndexOf('-fid-') + 5);

			for(let i=0; i<items.length; i++){
				let item = items[i];
				if(item.fieldId == fieldId && item.fieldType == 'accountItem'){
					if(!isRemoved){
						item.value = selectedValueName;
						item.accountLedgerId = selectedValueId;
					}
					else{
						item.value = null;
						item.accountLedgerId = null;	
					}
					this.$forceUpdate();
					break;
				}
			}
		},
		fn_updateLinkedItem: function (selectedValueId, selectedValueName, isRemoved, ref) {
			let items = this.$parent.Form.dynamicFields.items;

			let fieldRef = ref ? ref : this.$parent.Form.dynamicFields.ref;

			let fieldId = fieldRef.substring(fieldRef.lastIndexOf('-fid-') + 5);
			
			for(let i=0; i<items.length; i++){
				let item = items[i];
				if(item.fieldId == fieldId && item.fieldType=='linkedItem'){
					if(!isRemoved){
						item.value = selectedValueName;
						item.listItemId = selectedValueId;
					}
					else{
						item.value = null;
						item.listItemId = null;	
					}
					this.$forceUpdate();
					break;
				}
			}
		},
		fn_updateCheckBoxValue: function(item){
			this.$forceUpdate();
			!item.value ? item.value = null : '';
		},

		// fn_updateChoice: function(){
		// 	this.$forceUpdate();
		// 	console.log(JSON.stringify(this.$parent.Form.dynamicFields.items));
		// },
		// fn_updateDateFormat: function (date) {
		// 	this.dynamicFieldDate = this.$moment(date).format('DD-MMM-YYYY');
		// 	this.$forceUpdate();
		// },
		fn_checkValidations: function(){
			this.$route.query.section_id && this.$route.query.section_id != 'einvoice_details' ? this.isDirectSave = true : '';

			this.$validator.validateAll('fields').then((result) => {
		        if (result) {
		        	let emptyFields = true;
		        	for(let i=0; i<this.$parent.Form.dynamicFields.items.length; i++){
		        		if(this.$parent.Form.dynamicFields.items[i].value){
		        			emptyFields = false;
		        			break;
		        		}
		        	}
		        	// !emptyFields ? this.saveFields(this.$parent.Form.dynamicFields) : this.$parent.fn_closeDialog();
					if(emptyFields){
						this.$parent.fn_closeDialog();
					}
					else{
						if(this.$parent.Form.dynamicFields.isItemDetails){
							this.saveItemFields(this.$parent.Form.dynamicFields);
						}
						else{
							this.saveFields(this.$parent.Form.dynamicFields);
						}
					}
		        }
		    });
		},
		fn_updateDynamicDate: function(value, dateType){
			let fieldId = dateType.substring(dateType.lastIndexOf('-fid-') + 5);

			for(let i in this.$parent.Form.dynamicFields.items){
				if(this.$parent.Form.dynamicFields.items[i].fieldId == fieldId && this.$parent.Form.dynamicFields.items[i].fieldType == 'dateTime'){
					// this.$set(this.$parent.Form.dynamicFields.items[i], 'value', value);
					let date = this.$root.fn_getLocalDateFormat(value);
					this.$set(this.$parent.Form.dynamicFields.items[i], 'value', date);
					this.$forceUpdate();
					break;
				}
			}
		},
		fn_formatDate: function(val){
			let date = val ? new Date(val) : null;
			return date ? this.$moment(date).format('DD-MMM-YYYY') : null;
		},

		fn_assignChoiceFields: function(item){
			if(item && item.displayName == 'Sub Type' && this.$parent.Form.dynamicFields.items && this.$parent.Form.dynamicFields.items.length){
				let docTypeIndex = this.$parent.Form.dynamicFields.items.findIndex(field=>{return field.displayName == 'Document Type'});
				this.$parent.Form.dynamicFields.items[docTypeIndex].value = null;
				// this.documentTypeChoices = [];
				// this.$parent.Form.dynamicFields.items[docTypeIndex].filteredChoices = [];

				if(item.value && (item.value == 'Supply' || item.value == 'Export')){
					this.$parent.Form.dynamicFields.items[docTypeIndex].filteredChoices = this.$parent.Form.dynamicFields.items[docTypeIndex].additionalData.choices.filter(choice=>{return choice == 'Tax Invoice' || choice == 'Bill Of Supply'})
				}
				else if(item.value && (item.value == 'Job Work' || item.value == 'For Own Use' || item.value == 'Exhibition Or Fairs' || item.value == 'Job Work' || item.value == 'Lines Sales')){
					this.$parent.Form.dynamicFields.items[docTypeIndex].filteredChoices = this.$parent.Form.dynamicFields.items[docTypeIndex].additionalData.choices.filter(choice=>{return choice == 'Challan'})
				}
				else if(item.value && item.value == 'SKD/CKD'){
					this.$parent.Form.dynamicFields.items[docTypeIndex].filteredChoices = this.$parent.Form.dynamicFields.items[docTypeIndex].additionalData.choices.filter(choice=>{return choice == 'Tax Invoice' || choice == 'Bill Of Supply' || choice == 'Challan' || choice == 'Bill Of Entry'})
				}
				else if(item.value && (item.value == 'Recipient Not Known' || item.value == 'Others')){
					this.$parent.Form.dynamicFields.items[docTypeIndex].filteredChoices = this.$parent.Form.dynamicFields.items[docTypeIndex].additionalData.choices.filter(choice=>{return choice == 'Challan' || choice == 'Others'})
				}
				else if(item.value && item.value == 'Import'){
					this.$parent.Form.dynamicFields.items[docTypeIndex].filteredChoices = this.$parent.Form.dynamicFields.items[docTypeIndex].additionalData.choices.filter(choice=>{return choice == 'Bill Of Entry'})
				}
				else{
					this.$parent.Form.dynamicFields.items[docTypeIndex].filteredChoices = [];
				}
				this.$forceUpdate();
			}
			// else{
			// 	item.filteredChoices = item.additionalData.choices;
			// }
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/components/dialogs/dialog_dynamic_fields.vue